import { render, staticRenderFns } from "./LeaderboardNumberOfPlayers.vue?vue&type=template&id=2af0cb34"
import script from "./LeaderboardNumberOfPlayers.vue?vue&type=script&lang=js"
export * from "./LeaderboardNumberOfPlayers.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardNumberOfPlayers.vue?vue&type=style&index=0&id=2af0cb34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports